import { addDoc, deleteDoc, collection, doc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export const convertDefectToFeature = async (defect) => {
  try {
    // Create feature request from defect
    const featureData = {
      title: defect.title,
      description: `**Test Step:**\n${defect.testStep}\n\n**Expected Result:**\n${defect.expectedResult}\n\n**Actual Result:**\n${defect.actualResult}`,
      applicationName: defect.applicationName || '',
      mockupImageUrl: defect.expectedResultImageUrl || defect.actualResultImageUrl || '',
      priority: defect.priority,
      status: 'Submitted',
      votes: {},
      voteCount: 0,
      assignedToDev: defect.assignedToFix || '',
      assignedToTest: defect.assignedToTest || '',
      comments: defect.comments || [],
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      createdBy: defect.createdBy,
      createdByEmail: defect.createdByEmail,
      convertedFrom: 'defect',
      originalDefectId: defect.id
    };
    
    const newFeature = await addDoc(collection(db, 'featureRequests'), featureData);
    
    // Delete original defect
    await deleteDoc(doc(db, 'defects', defect.id));
    
    return newFeature.id;
  } catch (error) {
    console.error('Error converting defect to feature:', error);
    throw error;
  }
};

export const convertFeatureToDefect = async (feature) => {
  try {
    // Create defect from feature request
    const defectData = {
      title: feature.title,
      applicationName: feature.applicationName || '',
      testStep: feature.description || '',
      expectedResult: 'Implementation as described in feature request',
      actualResult: 'Not yet implemented',
      expectedResultImageUrl: feature.mockupImageUrl || '',
      actualResultImageUrl: '',
      priority: feature.priority,
      status: 'Open',
      assignedToFix: feature.assignedToDev || '',
      assignedToTest: feature.assignedToTest || '',
      comments: feature.comments || [],
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      createdBy: feature.createdBy,
      createdByEmail: feature.createdByEmail,
      convertedFrom: 'feature',
      originalFeatureId: feature.id
    };
    
    const newDefect = await addDoc(collection(db, 'defects'), defectData);
    
    // Delete original feature
    await deleteDoc(doc(db, 'featureRequests', feature.id));
    
    return newDefect.id;
  } catch (error) {
    console.error('Error converting feature to defect:', error);
    throw error;
  }
};
